import React, { useEffect, useMemo } from 'react'
import * as Sentry from '@sentry/browser'

import { FlagsProvider, defaultFlags } from 'containers/flags'

import useUserProfile from 'modules/user/useUserProfile'
import { useDevToolsFlags } from 'modules/devtools/useDevToolsFlags'

const formatArrayIntoObject = (flags: string[]) =>
  flags.reduce((acc, value) => ({ ...acc, [value]: true }), {})

const mapValuesToString = (flags: { [key: string]: boolean }) =>
  Object.fromEntries(Object.entries(flags).map(([k, v]) => [k, String(v)]))

const ConnectedFlagsProvider: React.FC = ({ children }) => {
  const { data } = useUserProfile()

  const featureFlags = (data?.me?.featureFlags ?? []).map(f => f as string)

  const { localFlagOverrides } = useDevToolsFlags()

  const flags = useMemo(
    () => ({
      ...defaultFlags,
      ...formatArrayIntoObject(featureFlags),
      ...localFlagOverrides,
    }),
    [featureFlags, localFlagOverrides]
  )

  useEffect(() => {
    const sentryFlags = mapValuesToString(flags)

    Sentry.configureScope(scope => {
      scope.setContext('Feature Flags', sentryFlags)
    })
  }, [flags])

  return <FlagsProvider value={flags}>{children}</FlagsProvider>
}

export default ConnectedFlagsProvider
